"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatISODateShort = exports.secondsToDate = exports.getNextWednesday = exports.time = void 0;
const luxon_1 = require("luxon");
/**
 * Given an async function, executes that function and
 * returns the time it took to complete and its result.
 *
 * @returns Number of milliseconds that the given async function took to complete and its result
 */
const time = async (fn) => {
    const startTime = new Date();
    const result = await fn();
    return { ms: new Date().getTime() - startTime.getTime(), result };
};
exports.time = time;
const getNextWednesday = () => {
    let nextWednesday = luxon_1.DateTime.utc();
    // If after this week's tuesday
    if (nextWednesday.weekday > 2) {
        // Go to next week
        nextWednesday = nextWednesday.plus({ week: 1 });
    }
    // Go to this week's wednesday
    nextWednesday = nextWednesday.set({ weekday: 3 });
    return nextWednesday;
};
exports.getNextWednesday = getNextWednesday;
const secondsToDate = (seconds) => new Date(seconds * 1000);
exports.secondsToDate = secondsToDate;
/**
 * '2022-11-08' -> 'Nov 8'
 */
const formatISODateShort = (date) => luxon_1.DateTime.fromISO(date).toFormat("MMM d");
exports.formatISODateShort = formatISODateShort;
//# sourceMappingURL=time_utils.js.map